import { NavigationEnd, Router } from '@angular/router';
import { merge } from 'rxjs';
import { filter, skip, tap } from 'rxjs/operators';

import { AuthStatus } from '../auth/auth.model';
import { AuthService } from '../auth/auth.service';

import {
    clearCoachingInsightUser,
    clearSessionStorage,
} from './oa/opportunityalignment/coachingInsight-session-storage-functions';

/** @deprecated */
export function logoutWatcher(router: Router, authService: AuthService): void {
    merge(
        router.events.pipe(
            filter<NavigationEnd>(
                (event) =>
                    event instanceof NavigationEnd && event.url === '/logout',
            ),
        ),
        authService.authStatus.asObservable().pipe(
            skip(1),
            filter((next) => next === AuthStatus.UNAUTHENTICATED),
        ),
    )
        .pipe(
            tap(() => clearSessionStorage()),
            tap(() => clearCoachingInsightUser()),
        )
        .subscribe();
}
